import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '../../../../configs/APIConfig/axiosInstance'
import { openNotification, errorHandling } from '../../../../utils/utils'

export const useDeleteServiceFQA = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id) => {
      const response = await axios.delete(`/admin/service_fqa/${id}`)
      return response.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['FQAS'])
      openNotification('success', data.message)
    },
    onError: (error) => {
      const { message } = errorHandling(error)
      openNotification('error', message)
    },
  })
}
